import React from 'react';
import { SettingsListType } from './types';

type Props = { list: SettingsListType[] };

const ProfileSettings = ({ list }: Props) => {
  return (
    <div>
      <div className='space-y-4 mt-6'>
        {list?.map(({ label, onClick, value, description, buttonText, buttonClass }, i) => (
          <div className='flex items-center border-b border-b-gray-13 pb-4 ' key={i}>
            <div className='flex flex-col grow'>
              <label className='text-xs text-gray-9'>{label}</label>
              <div className='flex items-center gap-3'>
                <p className='text-sm'>{value}</p>
                {description && (
                  <div className='text-red-5 text-xs bg-red-1 py-1 px-3 w-fit rounded-full '>
                    {description}
                  </div>
                )}
              </div>
            </div>

            <button
              className={`w-[86px] h-[34px] rounded-[100px] bg-[#F2F2F2] hover:bg-gray-4 font-medium text-xs text-gray-9 ${buttonClass}`}
              onClick={onClick}>
              {buttonText ? buttonText : 'Change'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSettings;
